/* eslint-disable @typescript-eslint/no-explicit-any */
export const ELM_ACTION = 'UNIQUE_STRING_ELM_ACTION';

export default (store: any) => (next: any) => (action: any) => {
   
  if (action[ELM_ACTION]) {
    return null;
  }
  return next(action);
};
